/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ProtectedRoute } from './components/ProtectedRoute';
import { useGlobalSlice } from './slice';
import { ThemeProvider } from './components/ui/theme-provider';
import { NotFoundPage } from './pages/NotFoundPage';
import HomePage from './pages/HomePage';
import SessionGuard from './components/SessionGuard';
// import { useCalendarSlice } from './pages/Calendar/slice';

// import { GlobalStyle } from 'styles/global-styles';
import { Toaster } from "app/components/ui/sonner";
import { Login } from './pages/Login/Loadable';
import { ResetPasswordPage } from './pages/ResetPassword/Loadable';
import { Dashboard } from './pages/Dashboard/Loadable';
import { ProductList } from './pages/ProductList/Loadable';
import { ProductCreate } from './pages/ProductCreate/Loadable';
import { ProductEdit } from './pages/ProductEdit/Loadable';
import { ProfileSettings } from './pages/ProfileSettings/Loadable';
import { TemplateSetting } from './pages/TemplateSetting/Loadable';
import { Employees } from './pages/Employees/Loadable';
import { ARSettings } from './pages/ARSettings/Loadable';
import { Analytics } from './pages/Analytics/Loadable';
import { LocalizationManagement } from './pages/LocalizationManagement/Loadable';
import { RenderLogs } from './pages/RenderLogs/Loadable';

// Pre-inject commonly used slices to avoid render-time injection
import { useProductListSlice } from './pages/ProductList/slice';
import { useDashboardSlice } from './pages/Analytics/slice';
import { selectUser } from './slice/selectors';
import { useEffect } from 'react';

export function App() {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const { actions, useGetCompanyQuery } = useGlobalSlice();

  // Pre-inject commonly used slices at app level to prevent setState during render
  // useProductListSlice();
  // useDashboardSlice();

  // Initialize authentication state on app startup
  React.useEffect(() => {
    dispatch(actions.initializeAuth());
  }, [dispatch, actions]);

  return (
    <BrowserRouter>
      <ThemeProvider defaultTheme="light">
        <Helmet
          titleTemplate="%s - Zieny AI"
          defaultTitle="Zieny AI"
          htmlAttributes={{ lang: i18n.language }}
        >
          <meta
            name="description" content="Zieny AI" />
        </Helmet>
        <Toaster position="top-center" />
        <Routes>
          <Route element={<ProtectedRoute />}>
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/analytics" element={<Analytics />} />
            <Route path="/admin/products" element={<ProductList />} />
            <Route path="/admin/products/create" element={<ProductCreate />} />
            <Route path="/admin/products/:id/edit" element={<ProductEdit />} />
            <Route path="/admin/profile-settings" element={<ProfileSettings />} />
            <Route path="/admin/template-setting" element={<TemplateSetting />} />
            {/* <Route path="/admin/employees" element={<Employees />} /> */}
            <Route path="/admin/ar-settings" element={<ARSettings />} />
            <Route path="/admin/localization" element={<LocalizationManagement />} />
            <Route path="/admin/render-logs" element={<RenderLogs />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/" element={<Login />} />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
}
